import { environment } from "./../../../../environments/environment.prod";
import { ActionReducerMap, MetaReducer } from "@ngrx/store";

import { State as RootState } from "../../../store/reducers";
import { State as CoreState, reducer as coreReducer } from "./core.reducer";

import {
  State as CatalogueState,
  reducer as catalogueReducer,
} from "./catalogue.reducer";

export interface CoreFeatureState {
  catalogue: CatalogueState;
  core: CoreState;
}

export interface State extends RootState {
  core_feature: CoreFeatureState;
}

export const reducers: ActionReducerMap<CoreFeatureState> = {
  catalogue: catalogueReducer,
  core: coreReducer,
} as ActionReducerMap<CoreFeatureState>;

export const metaReducers: MetaReducer<State>[] = !environment.production
  ? []
  : [];
